/**
 * 2022 Tax Year Rules
 * Combines federal and state rules
 */

import { TaxRules } from '../../types';
import { cashMedicalSupportLevelsIA2022 } from './IA/cashMedicalSupportLevels';
import { childSupportLevelsIA2022 } from './IA/childSupportLevels';

export const taxRules2022: TaxRules = {
    year: 2022,
    federal: {
        filing: {
            single: {
                standardDeduction: 12950,
                over65Deduction: 1750,
                blindDeduction: 1750,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 10275.99, rate: 0.10 },
                    { minimumIncome: 10276, maximumIncome: 41775.99, rate: 0.12 },
                    { minimumIncome: 41776, maximumIncome: 89075.99, rate: 0.22 },
                    { minimumIncome: 89076, maximumIncome: 170050.99, rate: 0.24 },
                    { minimumIncome: 170051, maximumIncome: 215950.99, rate: 0.32 },
                    { minimumIncome: 215951, maximumIncome: 539900.99, rate: 0.35 },
                    { minimumIncome: 539901, rate: 0.37 },
                ],
            },
            marriedFilingSeparately: {
                standardDeduction: 12950,
                over65Deduction: 1400,
                blindDeduction: 1400,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 10275.99, rate: 0.10 },
                    { minimumIncome: 10276, maximumIncome: 41775.99, rate: 0.12 },
                    { minimumIncome: 41776, maximumIncome: 89075.99, rate: 0.22 },
                    { minimumIncome: 89076, maximumIncome: 170050.99, rate: 0.24 },
                    { minimumIncome: 170051, maximumIncome: 215950.99, rate: 0.32 },
                    { minimumIncome: 215951, maximumIncome: 323925.99, rate: 0.35 },
                    { minimumIncome: 323926, rate: 0.37 },
                ],
            },
            headOfHousehold: {
                standardDeduction: 19400,
                over65Deduction: 1750,
                blindDeduction: 1750,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 14650.99, rate: 0.10 },
                    { minimumIncome: 14651, maximumIncome: 55900.99, rate: 0.12 },
                    { minimumIncome: 55901, maximumIncome: 89050.99, rate: 0.22 },
                    { minimumIncome: 89051, maximumIncome: 170050.99, rate: 0.24 },
                    { minimumIncome: 170051, maximumIncome: 215950.99, rate: 0.32 },
                    { minimumIncome: 215951, maximumIncome: 539900.99, rate: 0.35 },
                    { minimumIncome: 539901, rate: 0.37 },
                ],
            },
        },
        fica: {
            regularSocialSecurityRate: 6.2,
            seSocialSecurityRate: 12.4,
            regularMedicareRate: 1.45,
            seMedicareRate: 2.9,
            additionalMedicareTaxRate: 0.90,
            socialSecurityThreshold: 147000,
            additionalMedicareTaxThreshold: 200000,
        },
        credits: {
            federalCreditPerDependentUnder17: 2000,
            federalRefundableAmountPerChildUnder17: 1500,
            federalCreditPerDependent17Over: 500,
            childTaxCreditPhaseOutThreshold: 200000,
            phaseOutAmountPerChild: 50,
            dollarAbovePhaseoutThresholdIncrement: 1000,
        },
        qbi: {
            thresholdStart: 170050,
            thresholdEnd: 999_999_999_999,
            tentativeRate: 999_999_999,
            thresholdRate: 2.5,
        },
        earnedIncome: {
            threshold: 2500,
            agiMultiplier: 15, // as percentage
        },
        dependentCare: {
            limitOneDependent: 3000,
            limitTwoOrMoreDependents: 6000,
        }
    },
    states: {
        IA: {
            // Iowa state tax - progressive brackets for 2022 (9 brackets)
            standardDeductionSingle: 2210,
            standardDeductionMarriedFilingSeparately: 2210,
            standardDeductionHeadOfHousehold: 5450,
            over65Deduction: 20,
            blindDeduction: 20,
            brackets: [
                { minimumIncome: 0, maximumIncome: 1743.99, rate: 0.0033 },
                { minimumIncome: 1744, maximumIncome: 3486.99, rate: 0.0067 },
                { minimumIncome: 3487, maximumIncome: 6972.99, rate: 0.0225 },
                { minimumIncome: 6973, maximumIncome: 15687.99, rate: 0.0414 },
                { minimumIncome: 15688, maximumIncome: 26145.99, rate: 0.0563 },
                { minimumIncome: 26146, maximumIncome: 34860.99, rate: 0.0596 },
                { minimumIncome: 34861, maximumIncome: 52290.99, rate: 0.0625 },
                { minimumIncome: 52291, maximumIncome: 78435.99, rate: 0.0744 },
                { minimumIncome: 78436, rate: 0.0853 },
            ],
            personalCredit: {
                single: 40,
                marriedFilingSeparately: 40,
                headOfHousehold: 80,
                perDependent: 40,
            },
            qadd: [
                { count: 0, rate: 0.00, minimum: 0 },
                { count: 1, rate: 0.08, minimum: 9_600 },
                { count: 2, rate: 0.12, minimum: 14_400 },
                { count: 3, rate: 0.14, minimum: 16_800 },
                { count: 4, rate: 0.15, minimum: 18_000 },
                { count: 5, rate: 0.16, minimum: 19_200 },
            ],
            support: {
                childSupport: childSupportLevelsIA2022,
                cashMedicalSupport: cashMedicalSupportLevelsIA2022,
            },
        },
    }
};

